export const LandlordEntityType = {
  individual: 'individual',
  company: 'company',
};
